import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';

import { GroupOrderModal } from '@order/features-group-ordering';

import { GroupOrderShareContent, NotFoundView } from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderShareScreen = () => {
  const router = useRouter();
  const { formatMessage } = useIntl();
  const { joinCode } = useLocalSearchParams<GroupOrderShareScreenParams>();

  // ─── Handlers ─────────────────────────────────────────────────────────

  const navigateToBag = useCallback(() => {
    router.replace('/bag');
  }, [router]);

  const closeScreen = useCallback(() => {
    router.back();
  }, [router]);

  // ─────────────────────────────────────────────────────────────────────

  if (!joinCode) return <NotFoundView />;

  return (
    <GroupOrderModal
      accessibilityLabel={formatMessage(messages.dialogA11yLabel)}
      onClose={closeScreen}
    >
      <GroupOrderShareContent joinCode={joinCode} onClose={closeScreen} onDone={navigateToBag} />
    </GroupOrderModal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  dialogA11yLabel: {
    defaultMessage: 'Share group order',
    description: 'Group Order Share | Dialog a11y label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderShareScreenParams = {
  joinCode?: string;
};
